(function () {
  'use strict';

  var ajax = new XMLHttpRequest();
  ajax.open("GET", "img/svg/sprite.svg?v=362f94b", true);
  ajax.onload = function () {
    var div = document.createElement("div");
    div.innerHTML = ajax.responseText;
    document.body.insertBefore(div, document.body.childNodes[0]);
  };
  ajax.send();
})();
